import DataNotFound from '@/components/data-not-found/DataNotFound';
import PartnerWrapper from '@/partner/components/wrapper/Wrapper';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table"
import parse from "html-react-parser"

const PurchasedServices = () => {
    const { state: services } = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    if (!services) {
        navigate(-1);
    }
    return (
        <PartnerWrapper>
            <div>
                <div className="section-heading-container">
                    <h1 className='section-heading'>Purchased Services</h1>
                </div>

                <Table className="mt-5">
                    <TableHeader className="bg-[#E5E7EB]">
                        <TableRow className="text-lg">
                            <TableHead>Icon</TableHead>
                            <TableHead>Name</TableHead>
                            <TableHead>Category</TableHead>
                            <TableHead>Description</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {services?.map((service) => (
                            <TableRow key={service?.serviceId?._id}>
                                <TableCell>
                                    <div onClick={() => navigate(`/partner/clients/${params?.clientId}/service/${service?._id}`, { state: service?.serviceId })} className="w-12 cursor-pointer h-12 rounded-full bg-slate-500">
                                        <img className="w-full h-full rounded-full" src={`${import.meta.env.VITE_IMG_URL}/${service?.serviceId?.icon}`} alt="service" />
                                    </div>
                                </TableCell>
                                <TableCell>
                                    <h3 onClick={() => navigate(`/partner/clients/${params?.clientId}/service/${service?._id}`, { state: service?.serviceId })} className="text-lg cursor-pointer font-semibold">{service?.serviceId?.name}</h3>
                                </TableCell>
                                <TableCell>{service?.serviceId?.categoryId?.name}</TableCell>
                                <TableCell className="w-80 line-clamp-2">{service?.serviceId?.description && parse(service?.serviceId?.description)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

                {services.length === 0 &&
                    <DataNotFound name={"Services"} />
                }
            </div>
        </PartnerWrapper>
    )
}

export default PurchasedServices